function AdminStats({ stats, loading }) {
    if (loading) {
        return <div>Loading stats...</div>;
    }

    if (!stats) {
        return <div>No stats available</div>;
    }

    const statLabels = {
        "total_students": "Total Students",
        "total_projects": "Total Projects",
        "total_professors": "Total Professors",
        "confirmed_students": "Confirmed Students",
        "unconfirmed_students": "Unconfirmed Students",
        "round_1_students": "Round 1 Students",
        "round_2_students": "Round 2 Students",
        "round_3_students": "Round 3 Students"
    };

    return (
        <div className="admin-stats">
            <h2>Student Statistics</h2>
            <div className="table-wrapper">
                <table className="sip-table">
                    <thead>
                        <tr>
                            <th>Metric</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(stats).map(([key, value]) => (
                            <tr key={key}>
                                <td>{statLabels[key] || key}</td>
                                <td>{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AdminStats;